import CanvasRect from "../gameEngines/simpleCanvas/CanvasRect";
import { CanvasRectProps } from "../gameEngines/simpleCanvas/CanvasRect";
import CanvasElement from "../gameEngines/simpleCanvas/CanvasElement";
import { interfaceColors as colors } from "../common/interfaceColors";

export interface LightOnRectProps extends CanvasRectProps {
  lit?: boolean;
  gridx: number;
  gridy: number;
  onChange: () => void;
}

export default class LightOnRect extends CanvasRect {
  public lit: boolean;
  public gridx: number;
  public gridy: number;
  public onChange: () => void;
  public solveStep: number | null = null;

  constructor({
    lit = false,
    gridx,
    gridy,
    onChange,
    ...rest
  }: LightOnRectProps) {
    super({ ...rest });
    this.lit = lit;
    this.gridx = gridx;
    this.gridy = gridy;
    this.onChange = onChange;
  }

  public draw(canvas: HTMLCanvasElement) {
    this.fillColor = this.lit ? colors.action : colors.panel;
    this.lineColor = colors.border;
    super.draw(canvas);

    if (this.solveStep !== null) {
      const context = canvas.getContext("2d");
      if (!context) return;
      const cx = this.x + this.width / 2;
      const cy = this.y + this.height / 2;
      const radius = Math.min(this.width, this.height) * 0.25;

      context.beginPath();
      context.arc(cx, cy, radius, 0, Math.PI * 2);
      context.fillStyle = "rgba(255, 152, 0, 0.9)";
      context.fill();
      context.strokeStyle = "#E65100";
      context.lineWidth = 2;
      context.stroke();
      context.lineWidth = 1;
    }
  }

  public getLightOnRects(elements: CanvasElement[]): LightOnRect[] {
    return elements as LightOnRect[];
  }

  public onClick(elements: CanvasElement[]) {
    if (this.active) {
      this.lit = !this.lit;
      const lightOnRects = this.getLightOnRects(elements);
      const above = lightOnRects.find(
        (rect) => rect.gridx === this.gridx && rect.gridy === this.gridy - 1
      );
      const below = lightOnRects.find(
        (rect) => rect.gridx === this.gridx && rect.gridy === this.gridy + 1
      );
      const left = lightOnRects.find(
        (rect) => rect.gridx === this.gridx - 1 && rect.gridy === this.gridy
      );
      const right = lightOnRects.find(
        (rect) => rect.gridx === this.gridx + 1 && rect.gridy === this.gridy
      );
      [above, below, left, right].forEach((rect) => {
        if (rect) {
          rect.lit = !rect.lit;
        }
      });
      this.onChange();
    }
  }
}
